import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../utils/config";

// Tạo async thunk để lấy danh sách dịch vụ từ API
export const getListTrademarkCompanyMap = createAsyncThunk(
  "trademarkCompanyMap/getListTrademarkCompanyMap",
  async ({ mCouponBranchId, currentPage, pageSize }, { rejectWithValue }) => {
    try {
      let apiUrl = `/api/v1/serviceconnect/trademark-companies?mcoupon_branch_id=${mCouponBranchId}&has_paginate&size=${pageSize}&page=${currentPage}`;
      const response = await http.get(apiUrl);
      return response.data;
    } catch (error) {
      return rejectWithValue("Có lỗi xảy ra trong quá trình kết nối");
    }
  }
);

// Lấy TOÀN BỘ liên kết thương hiệu ↔ đơn vị (mọi branch của shop)
export const getAllTrademarkCompanyMap = createAsyncThunk(
  "trademarkCompanyMap/getAllTrademarkCompanyMap",
  async (params = {}, { rejectWithValue }) => {
    try {
      const q = new URLSearchParams();
      if (params.mcoupon_branch_id) q.set("mcoupon_branch_id", params.mcoupon_branch_id);
      if (params.trademark_id) q.set("trademark_id", params.trademark_id);
      const response = await http.get(
        `/api/v1/serviceconnect/trademark-companies/all?${q.toString()}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Có lỗi xảy ra");
    }
  }
);

export const createTrademarkCompanyMap = createAsyncThunk(
  "trademarkCompanyMap/createTrademarkCompanyMap",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.post(`/api/v1/serviceconnect/trademark-companies`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteTrademarkCompanyMap = createAsyncThunk(
  "trademarkCompanyMap/deleteTrademarkCompanyMap",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.post(`/api/v1/serviceconnect/trademark-companies/delete`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateTrademarkCompanyMapStatus = createAsyncThunk(
  "trademarkCompanyMap/updateTrademarkCompanyMapStatus",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await http.put(`/api/v1/serviceconnect/trademark-companies/${id}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);